import React from 'react';
import type { ThankYouPostData } from '../../types';
import { HandsPrayingIcon } from '@phosphor-icons/react';
import { Badge } from '@/components/ui/badge';
import { toWords } from 'to-words';
import { MentionText } from '@/components/mentions/MentionText';

interface ThankYouPostContentProps {
  post: ThankYouPostData;
}

export function ThankYouPostContent({ post }: ThankYouPostContentProps) {
  const businessType = post.businessType;
  return (
    <div className="space-y-4">
      <div className="space-y-1.5">
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-2">
            <HandsPrayingIcon className="h-5 w-5 text-green-500 fill-green-500" />
            <span className="font-medium text-foreground">Business Thank You</span>
          </div>
          <Badge
            variant={businessType === 'INTERNAL' ? 'secondary' : 'default'}
            className="text-center"
          >
            {businessType === 'INTERNAL' ? 'Internal' : 'External'}
          </Badge>
        </div>
        {(post.thankYouRecipientFirstName || post.thankYouToUserName || post.communityName) && (
          <p className="text-xs text-muted-foreground mt-2">
            To:{' '}
            <span className="text-lg text-muted-foreground font-bold">
              {post.thankYouRecipientFirstName || post.thankYouRecipientLastName
                ? `${post.thankYouRecipientFirstName ?? ''} ${post.thankYouRecipientLastName ?? ''}`.trim()
                : post.thankYouToUserName?.trim() || `${post.communityName} Community`}
            </span>
          </p>
        )}
      </div>
      <div className="bg-gradient-to-br from-green-500/10 to-emerald-500/10 p-6 rounded-xl border border-green-500/20 text-center space-y-2">
        <p className="text-3xl font-bold text-green-600 dark:text-green-400">
          ₹{Number(post.thankYouAmount).toLocaleString('en-IN')}
        </p>
        <p className="text-m text-muted-foreground">
          {toWords(Number(post.thankYouAmount), { localeCode: 'en-IN', currency: true })}
        </p>
        <p className="text-sm text-muted-foreground">Business Closed</p>
      </div>
      <p className="whitespace-pre-wrap text-sm text-foreground/90 text-center italic">
        "<MentionText text={post.thankYouMessage || ''} />"
      </p>
    </div>
  );
}
